export default function(state, initialState) {
  Object.keys(state).forEach((key) => {
    state[key] = initialState[key]
  })
}